document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-fio-add]');
  if (!btn) return;
  e.preventDefault();
  var id = btn.getAttribute('data-fio-add');
  if (!id) return;
  var label = btn.textContent;
  btn.textContent = 'ADICIONANDO…';
  btn.disabled = true;
  var drawer = document.querySelector('cart-drawer');
  var body = { items: [{ id: Number(id), quantity: 1 }] };
  if (drawer && drawer.getSectionsToRender) {
    body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
    body.sections_url = window.location.pathname;
  }
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body)
  })
    .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
    .then(function (data) {
      if (drawer && data.sections && drawer.renderContents) {
        var item = data.items && data.items[0] ? data.items[0] : {};
        item.sections = data.sections;
        drawer.renderContents(item);
        if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
      } else {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        return;
      }
      btn.textContent = 'ADICIONADO ✓';
      setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1600);
    })
    .catch(function () {
      btn.textContent = 'ESCOLHA O TAMANHO';
      setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1800);
    });
});
